// src/Theme.js
import { createTheme } from '@mui/material/styles';

// NOTA: Ricorda di aggiungere questo link nel tag <head>
// del tuo file public/index.html:
// <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap" rel="stylesheet">

// --- Stili Scrollbar (Tema Scuro) ---
const darkScrollbarStyles = {
  // Per Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: '#444 #1A1A1A', // Manipolo: #444 (grigio) | Sfondo: #1A1A1A (colore 'paper')

  // Per Chrome, Edge, Safari
  '& *::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '& *::-webkit-scrollbar-track': {
    background: '#1A1A1A', // Sfondo del menu/carta
  },
  '& *::-webkit-scrollbar-thumb': {
    background: '#444', // Un grigio scuro
    borderRadius: '4px',
    border: '2px solid #1A1A1A', // Bordo con colore 'paper' per staccare
  },
  '& *::-webkit-scrollbar-thumb:hover': {
    background: '#777', // Un grigio più chiaro in hover
  }
};

// --- Stili Scrollbar (Tema Chiaro) ---
const lightScrollbarStyles = {
  // Per Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: '#c1c1c1 #ffffff', // Manipolo: grigio chiaro | Sfondo: bianco

  // Per Chrome, Edge, Safari
  '& *::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '& *::-webkit-scrollbar-track': {
    background: '#ffffff', // Sfondo 'paper' chiaro
  },
  '& *::-webkit-scrollbar-thumb': {
    background: '#c1c1c1', // Grigio chiaro
    borderRadius: '4px',
    border: '2px solid #ffffff', // Bordo bianco per staccare
  },
  '& *::-webkit-scrollbar-thumb:hover': {
    background: '#a8a8a8', // Grigio più scuro in hover
  }
};

// 1. IL TUO TEMA SCURO (AGGIORNATO)
export const darkTheme = createTheme({
  palette: {
    mode: 'dark', 
    primary: {
      main: '#FFFFFF',
    },
    secondary: {
      main: '#3f51b5',
    },
    background: {
      default: '#0A0A0A', 
      paper: '#1A1A1A',   
    },
    text: {
      primary: '#E0E0E0',
      secondary: '#B0B0B0', 
    },
    success: {
      main: '#4CAF50',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FFC107', 
      contrastText: '#000000',
    },
    error: {
      main: '#F44336', 
      contrastText: '#FFFFFF',
    },
    divider: 'rgba(255, 255, 255, 0.12)'
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  shape: {
    borderRadius: 12, 
  },
  components: {
    // --- MODIFICA AGGIUNTA QUI ---
    MuiCssBaseline: {
      styleOverrides: {
        body: darkScrollbarStyles, // Applica al body E a tutti gli elementi (*)
      },
    },
    // --- FINE MODIFICA ---
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', 
          fontWeight: 700,
          borderRadius: 8,
        },
        containedPrimary: {
          backgroundColor: '#FFFFFF',
          color: '#0A0A0A',
          '&:hover': {
            backgroundColor: '#E0E0E0',
          }
        }
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none', 
        },
      },
    },
  },
});


// 2. IL NUOVO TEMA CHIARO (AGGIORNATO)
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3f51b5', 
    },
    secondary: {
      main: '#FFFFFF',
    },
    background: {
      default: '#f4f6f8', 
      paper: '#ffffff',   
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    success: {
      main: '#4CAF50',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FFC107',
      contrastText: '#000000',
    },
    error: {
      main: '#F44336',
      contrastText: '#FFFFFF',
    },
    divider: 'rgba(0, 0, 0, 0.12)'
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    // --- MODIFICA AGGIUNTA QUI ---
    MuiCssBaseline: {
      styleOverrides: {
        body: lightScrollbarStyles, // Applica al body E a tutti gli elementi (*)
      },
    },
    // --- FINE MODIFICA ---
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});